import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerDto } from "app/models";
import { PlayerService } from "app/services";

@Component({
    selector: 'player-skills-modal',
    templateUrl: './player-skills.modal.html',
    styleUrls: ['./player-skills.modal.scss'],
})
export class PlayerSkillsModal implements OnInit {
    @Input()
    player: PlayerDto;

    useFormDependency: boolean = true;
    
    constructor (public activeModal: NgbActiveModal, private playerService: PlayerService) { }

    ngOnInit(): void {
    }

    getPositionLabel(): string {
        return this.playerService.formatPlayerPosition(this.player);
    }

    toggleSkillsDisplayMode() {
        this.useFormDependency = !this.useFormDependency;
    }
}